var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { Para } from "@irati/ui/src/Labels";
import { H3 } from "@irati/ui/src/Headings";
import { TextButton as TextButtonBase } from "@irati/ui/src/Button";
import { perkbox } from "@irati/ui/src/global/colors";
import { pollUsersToStringTitle, pollUsersToStringSubtitle } from "@irati/recognition/utils/pollUsersToString";
import { injectIntl } from "@irati/utils/lang";
import { POLL } from "@irati/recognition/constants/feedTypes";
import xOfYVotes from "@irati/recognition/utils/polls/xOfYVotes";
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList";
import { CompanyValuesWrapper, Top, Bottom, EndDate as EndDateBase, Bold } from "../shared/layouts";
import WhoCreated from "../../WhoCreated";
import WhoRewardedBase from "../../WhoRewarded";
import TeamList from "../../TeamList";
import UsersTooltip from "../../shared/UsersTooltip";
import { Activity as IconsActivity } from "../../Icons";
import { AddReaction } from "../../Reactions";
import OccasionIcon from "../../shared/OccasionIcon";
import PollActions from "./Actions";
import { VIEW_VOTES } from "./Popup";
import { Comments, CreateComment } from "../shared/Comments";
var WhoRewarded = styled(WhoRewardedBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 10px;\n"], ["\n  margin-bottom: 10px;\n"])));
var EndDate = styled(EndDateBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var TextButton = styled(TextButtonBase)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), perkbox.blue);
var StyledPara = styled(Para)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  word-wrap: break-word;\n"], ["\n  word-wrap: break-word;\n"])));
var ViewPoll = /** @class */ (function (_super) {
    __extends(ViewPoll, _super);
    function ViewPoll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showEmojiPicker: false
        };
        _this.togglePickerModal = function () { return _this.setState(function (prevState) { return ({ showEmojiPicker: !prevState.showEmojiPicker }); }); };
        return _this;
    }
    ViewPoll.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, poll = _a.poll, selectScreen = _a.selectScreen, onDelete = _a.onDelete;
        var showEmojiPicker = this.state.showEmojiPicker;
        var textarea = null;
        var pollWinnersResults = poll.winners.results.map(function (_a) {
            var user = _a.user;
            return user;
        });
        var nbWinners = pollWinnersResults.length;
        var title = pollUsersToStringTitle(pollWinnersResults, formatMessage);
        var winner = nbWinners > 0 ? pollWinnersResults[0] : null;
        var subTitle = pollUsersToStringSubtitle(pollWinnersResults, poll.title, formatMessage);
        var showReward = nbWinners === 1;
        return (React.createElement(React.Fragment, null,
            React.createElement(Top, { className: "center" },
                React.createElement(H3, null,
                    React.createElement(UsersTooltip, { placement: "bottom", users: poll.winners.results.map(function (_a) {
                            var user = _a.user;
                            return user;
                        }) },
                        React.createElement(Bold, null, title)),
                    React.createElement("br", null),
                    subTitle,
                    React.createElement(TeamList, { teams: poll.teams.results, showMobileTooltip: false })),
                React.createElement(TextButton, { inline: false, onClick: function () { return selectScreen(VIEW_VOTES); } }, winner && xOfYVotes(poll, winner, formatMessage)),
                React.createElement(CompanyValuesWrapper, null,
                    React.createElement(OccasionIcon, { occasion: poll.occasion }),
                    React.createElement(CompanyValues, { companyValues: poll.companyValues })),
                React.createElement(EndDate, { endsAt: poll.endsAt, poll: true }),
                showReward &&
                    React.createElement(WhoRewarded, { reward: poll.reward, rewardOrder: poll.rewardOrder, user: poll.createdBy }),
                React.createElement(PollActions, { poll: poll, onDeleteSuccess: onDelete }),
                React.createElement(StyledPara, { className: "text-left" }, poll.desc),
                React.createElement(WhoCreated, { createdBy: poll.createdBy }),
                React.createElement(IconsActivity, { item: poll, type: POLL, onClickComment: function () { if (textarea) {
                        textarea.focus();
                    } }, togglePickerModal: this.togglePickerModal }),
                showEmojiPicker && React.createElement(AddReaction, { item: poll, togglePickerModal: this.togglePickerModal })),
            React.createElement(Bottom, null,
                React.createElement(CreateComment, { item: poll, type: POLL, key: poll.comments.results.length, inputRef: function (t) { textarea = t; } }),
                React.createElement(Comments, { item: poll }))));
    };
    ViewPoll.defaultProps = {
        id: "view-poll"
    };
    return ViewPoll;
}(Component));
export default injectIntl(ViewPoll);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
